import { render, staticRenderFns } from "./DashboardPatientQueueCard.vue?vue&type=template&id=01802889&scoped=true"
import script from "./DashboardPatientQueueCard.vue?vue&type=script&lang=js"
export * from "./DashboardPatientQueueCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardPatientQueueCard.vue?vue&type=style&index=0&id=01802889&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01802889",
  null
  
)

export default component.exports